type ClassValue = string | false | null | undefined | ClassValue[];

/** Minimal className merger (no external deps). */
export function cn(...inputs: ClassValue[]): string {
  const out: string[] = [];

  const walk = (value: ClassValue) => {
    if (!value) return;
    if (Array.isArray(value)) {
      value.forEach(walk);
      return;
    }
    out.push(value);
  };

  inputs.forEach(walk);
  return out.join(' ');
}

type VariantConfig = Record<string, Record<string, string>>;
type DefaultVariants = Record<string, string>;

/**
 * Lightweight cva-style helper used by Button.
 */
export function createVariants(
  base: string,
  variants: VariantConfig,
  defaults: DefaultVariants = {},
) {
  return (props: Record<string, string | undefined> & { className?: string } = {}) => {
    const parts = [base];
    for (const key of Object.keys(variants)) {
      const chosen = props[key] ?? defaults[key];
      if (chosen && variants[key][chosen]) {
        parts.push(variants[key][chosen]);
      }
    }
    if (props.className) parts.push(props.className);
    return cn(...parts);
  };
}
